export const ATOMO_API = `https://esagaming-api.esagaming.com/backend_atomo/esa_game_history.php`;
export const ATOMO_QA_API = 'https://testapi.esagaming.it/backend_atomo_qa/esa_game_history.php';
